import React, { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { zohoAPI } from '@/lib/api';
import { toast } from 'sonner';
import { User } from 'lucide-react';

export default function ZohoSubmitterFieldPicker({ form, onFormUpdated }) {
  const [saving, setSaving] = useState(false);
  const fields = form?.detected_fields || [];

  if (fields.length === 0) return null;

  const handleChange = async (val) => {
    const field = val === '_none' ? '' : val;
    setSaving(true);
    try {
      const res = await zohoAPI.updateForm(form.id, { submitter_field: field });
      onFormUpdated(res.data);
      toast.success(field ? `Submitter field set to "${field}"` : 'Submitter field cleared');
    } catch {
      toast.error('Failed to update');
    }
    setSaving(false);
  };

  return (
    <div className="flex items-center gap-3" data-testid="submitter-field-picker">
      <User className="h-4 w-4 text-muted-foreground shrink-0" />
      <Label className="text-xs text-muted-foreground whitespace-nowrap">Submitter field:</Label>
      <Select value={form.submitter_field || '_none'} onValueChange={handleChange} disabled={saving}>
        <SelectTrigger className="h-7 w-[200px] text-xs" data-testid="submitter-field-select">
          <SelectValue placeholder="Select field..." />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="_none">— Not set —</SelectItem>
          {fields.map(f => (
            <SelectItem key={f} value={f}>{f}</SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
